import { Component, Inject, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ClientEnvironment, ENVIRONMENT, FooterNavigation } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { arvalFooterConfig } from './model/customer/arval/arval-footer-config';
import { lufthansaFooterConfig } from './model/customer/lufthansa/lufthansa-footer-config';
import { vorwerkFooterConfig } from './model/customer/vorwerk/vorwerk-footer-config';
import { westlottoFooterConfig } from './model/customer/westlotto/westlotto-footer-config';
import { footerConfig } from './model/footer-config';
@Component({
  selector: 'sp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() footerNavigation!: FooterNavigation[];

  CustomClients = CustomClients;
  currentUrl!: string;

  constructor(
    @Inject(ENVIRONMENT) public readonly env: ClientEnvironment,
    private router: Router,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.router.url;
      }
    });
  }

  ngOnInit(): void {
    switch (this.env.brandingKey) {
      case CustomClients.Vorwerk: {
        this.footerNavigation = vorwerkFooterConfig(this.env);
        break;
      }
      case CustomClients.Arval: {
        this.footerNavigation = arvalFooterConfig(this.env);
        break;
      }
      case CustomClients.WestLotto: {
        this.footerNavigation = westlottoFooterConfig(this.env);
        break;
      }
      case CustomClients.LufthansaMediacenter:
      case CustomClients.LufthansaMedialounge:
        this.footerNavigation = lufthansaFooterConfig(this.env);
        break;
      default: {
        this.footerNavigation = footerConfig(this.env);
        break;
      }
    }
  }
}
